/** Reactions and gifts at the table (review 0022), apart so each language file stays within budget. */
export const socialEn = {
  "reaction.open": "React",
  "reaction.said": "{name}: {text}",
  "reaction.gg": "Good game",
  "reaction.congrats": "Congrats",
  "reaction.hurry": "Come on!",
  "reaction.sorry": "Sorry",
  "reaction.wow": "Wow!",
  "reaction.thanks": "Thanks",
  "reaction.smile": "smiling",
  "reaction.laugh": "laughing",
  "reaction.surprised": "surprised",
  "reaction.sad": "sad",
  "reaction.angry": "angry",
  "reaction.thumbs": "thumbs up",
  "reaction.clap": "applause",
  "reaction.fire": "on fire",
  "gift.send": "Send a gift",
  "gift.held": "{gift} from {name}",
  "gift.clear": "Remove {gift}",
  "gift.turtle": "Turtle",
  "gift.bottle": "Baby bottle",
  "gift.clover": "Lucky clover",
  "gift.tea": "Tea",
  "gift.coffee": "Arabic coffee",
  "gift.crown": "Crown",
  "gift.rose": "Rose",
  "gift.heart": "Heart",
  "gift.chocolate": "Chocolate",
  "social.mute": "Hide reactions and gifts",
  "social.unmute": "Show reactions and gifts",
  "community.lead": "Meet other players:",
  "community.link": "High Card Club server",
  "data.gifts": "Gifts",
  "data.hideGifts": "Hide gifts at the table",
  "data.hideGifts.about": "You will not see gifts on anyone's picture on this device.",
} as const;

type SocialKey = keyof typeof socialEn;

export const socialTr: Record<SocialKey, string> = {
  "reaction.open": "Tepki",
  "reaction.said": "{name}: {text}",
  "reaction.gg": "İyi oyun",
  "reaction.congrats": "Tebrikler",
  "reaction.hurry": "Hadi!",
  "reaction.sorry": "Pardon",
  "reaction.wow": "Vay be!",
  "reaction.thanks": "Teşekkürler",
  "reaction.smile": "gülümsüyor",
  "reaction.laugh": "gülüyor",
  "reaction.surprised": "şaşırdı",
  "reaction.sad": "üzgün",
  "reaction.angry": "kızgın",
  "reaction.thumbs": "beğendi",
  "reaction.clap": "alkış",
  "reaction.fire": "ateş gibi",
  "gift.send": "Hediye gönder",
  "gift.held": "{gift}, gönderen {name}",
  "gift.clear": "{gift} hediyesini kaldır",
  "gift.turtle": "Kaplumbağa",
  "gift.bottle": "Biberon",
  "gift.clover": "Şanslı yonca",
  "gift.tea": "Çay",
  "gift.coffee": "Arap kahvesi",
  "gift.crown": "Taç",
  "gift.rose": "Gül",
  "gift.heart": "Kalp",
  "gift.chocolate": "Çikolata",
  "social.mute": "Tepki ve hediyeleri gizle",
  "social.unmute": "Tepki ve hediyeleri göster",
  "community.lead": "Oyuncularla buluş:",
  "community.link": "High Card Club sunucusu",
  "data.gifts": "Hediyeler",
  "data.hideGifts": "Masada hediyeleri gizle",
  "data.hideGifts.about": "Bu cihazda kimsenin resminde hediye görmezsin.",
};

export const socialAr: Record<SocialKey, string> = {
  "reaction.open": "تفاعل",
  "reaction.said": "{name}: {text}",
  "reaction.gg": "لعب جيد",
  "reaction.congrats": "مبروك",
  "reaction.hurry": "يلا!",
  "reaction.sorry": "آسف",
  "reaction.wow": "واو!",
  "reaction.thanks": "شكرًا",
  "reaction.smile": "يبتسم",
  "reaction.laugh": "يضحك",
  "reaction.surprised": "متفاجئ",
  "reaction.sad": "حزين",
  "reaction.angry": "غاضب",
  "reaction.thumbs": "أعجبني",
  "reaction.clap": "تصفيق",
  "reaction.fire": "نار",
  "gift.send": "أرسل هدية",
  "gift.held": "{gift} من {name}",
  "gift.clear": "أزل {gift}",
  "gift.turtle": "سلحفاة",
  "gift.bottle": "رضّاعة",
  "gift.clover": "برسيم الحظ",
  "gift.tea": "شاي",
  "gift.coffee": "قهوة عربية",
  "gift.crown": "تاج",
  "gift.rose": "وردة",
  "gift.heart": "قلب",
  "gift.chocolate": "شوكولاتة",
  "social.mute": "إخفاء تفاعلاته وهداياه",
  "social.unmute": "إظهار تفاعلاته وهداياه",
  "community.lead": "تعرّف على لاعبين آخرين:",
  "community.link": "سيرفر High Card Club",
  "data.gifts": "الهدايا",
  "data.hideGifts": "إخفاء الهدايا على الطاولة",
  "data.hideGifts.about": "لن ترى هدايا على صورة أحد على هذا الجهاز.",
};
